import captions$1 from './en.js';
import captions$2 from './nl.js';

const captions = {
  en: captions$1,
  nl: captions$2
};
function languageFromCode(code) {
  const i = code.indexOf('-');
  return i >= 0 ? code.substr(0, i) : code;
}
function captionsForLanguage(languageCode) {
  var _a, _b;
  const code = languageCode.toLowerCase();
  return (_b = (_a = captions[code]) !== null && _a !== void 0 ? _a : captions[languageFromCode(code)]) !== null && _b !== void 0 ? _b : captions.en;
}
function applyParameters(caption, params) {
  return params && params.length > 0 ? caption.replace(/\{(\d+)\}/g, (match, index) => {
    return String(params[+index]);
  }) : caption;
}
function install(captionProvider) {
  return (language, key, params) => {
    let caption = captionProvider(language, key, params);
    if (caption === undefined) {
      caption = defaultCaptionProvider(language, key, params);
    }
    return caption;
  };
}
function defaultCaptionProvider(languageCode, key, params) {
  let node, part;
  if (key) {
    const path = key.split('.');
    node = captionsForLanguage(languageCode);
    while (node && (part = path.shift())) {
      node = node[part];
    }
  }
  return node && applyParameters(node, params);
}
class Captions {
  constructor(captionProvider) {
    this.provider = captionProvider ? install(captionProvider) : defaultCaptionProvider;
  }
}

export { Captions as default, defaultCaptionProvider };
